export const API_ERROR_CODE_I18N_REASON_PLATFORM_OPERATIONS: Record<string, string> = {
  ack_build_fallback: "common.errors.apiCodeReasons.platformOperations.ackBuildFallback",
  acquire_failed: "common.errors.apiCodeReasons.platformOperations.acquireFailed",
  admission_lease_release_failed:
    "common.errors.apiCodeReasons.platformOperations.admissionLeaseReleaseFailed",
  asset_remediation_invalid_payload:
    "common.errors.apiCodeReasons.platformOperations.assetRemediationInvalidPayload",
  asset_upload_failed: "common.errors.apiCodeReasons.platformOperations.assetUploadFailed",
  async_publish_failed: "common.errors.apiCodeReasons.platformOperations.asyncPublishFailed",
  callback_base_url_invalid:
    "common.errors.apiCodeReasons.platformOperations.callbackBaseUrlInvalid",
  callback_base_url_missing:
    "common.errors.apiCodeReasons.platformOperations.callbackBaseUrlMissing",
  contract_dead_lettered: "common.errors.apiCodeReasons.platformOperations.contractDeadLettered",
  create_failed_after_asset_upload:
    "common.errors.apiCodeReasons.platformOperations.createFailedAfterAssetUpload",
  cross_node_admission_lease_release_failed:
    "common.errors.apiCodeReasons.platformOperations.crossNodeAdmissionLeaseReleaseFailed",
  cross_node_admission_leases_release_failed:
    "common.errors.apiCodeReasons.platformOperations.crossNodeAdmissionLeasesReleaseFailed",
  deadlock: "common.errors.apiCodeReasons.platformOperations.deadlock",
  deadlock_recovery_failed:
    "common.errors.apiCodeReasons.platformOperations.deadlockRecoveryFailed",
  destroy_payload_kind_required:
    "common.errors.apiCodeReasons.platformOperations.destroyPayloadKindRequired",
  domain_dead_lettered: "common.errors.apiCodeReasons.platformOperations.domainDeadLettered",
  failure_patch_failed: "common.errors.apiCodeReasons.platformOperations.failurePatchFailed",
  handoff_failed: "common.errors.apiCodeReasons.platformOperations.handoffFailed",
  health_status_invalid: "common.errors.apiCodeReasons.platformOperations.healthStatusInvalid",
  heartbeat_rollback_failed:
    "common.errors.apiCodeReasons.platformOperations.heartbeatRollbackFailed",
  inbox_failure_mark_failed:
    "common.errors.apiCodeReasons.platformOperations.inboxFailureMarkFailed",
  inbox_failure_record_failed:
    "common.errors.apiCodeReasons.platformOperations.inboxFailureRecordFailed",
  inspect_failed: "common.errors.apiCodeReasons.platformOperations.inspectFailed",
  invalid_error_response: "common.errors.apiCodeReasons.platformOperations.invalidErrorResponse",
  invalid_success_response:
    "common.errors.apiCodeReasons.platformOperations.invalidSuccessResponse",
  local_cleanup_failed: "common.errors.apiCodeReasons.platformOperations.localCleanupFailed",
  lookup_failed: "common.errors.apiCodeReasons.platformOperations.lookupFailed",
  parse_failed: "common.errors.apiCodeReasons.platformOperations.parseFailed",
  programmer_error: "common.errors.apiCodeReasons.platformOperations.programmerError",
  projection_lock_conflict:
    "common.errors.apiCodeReasons.platformOperations.projectionLockConflict",
  projection_retry: "common.errors.apiCodeReasons.platformOperations.projectionRetry",
  read_failed: "common.errors.apiCodeReasons.platformOperations.readFailed",
  ready_projection_retry: "common.errors.apiCodeReasons.platformOperations.readyProjectionRetry",
  ready_status_transition_retry:
    "common.errors.apiCodeReasons.platformOperations.readyStatusTransitionRetry",
  reconcile_failed: "common.errors.apiCodeReasons.platformOperations.reconcileFailed",
  release_claim_failed: "common.errors.apiCodeReasons.platformOperations.releaseClaimFailed",
  release_failed: "common.errors.apiCodeReasons.platformOperations.releaseFailed",
  renew_failed: "common.errors.apiCodeReasons.platformOperations.renewFailed",
  report_failed: "common.errors.apiCodeReasons.platformOperations.reportFailed",
  request_mismatch: "common.errors.apiCodeReasons.platformOperations.requestMismatch",
  request_retry: "common.errors.apiCodeReasons.platformOperations.requestRetry",
  retry_dead_lettered: "common.errors.apiCodeReasons.platformOperations.retryDeadLettered",
  retry_later_dead_lettered:
    "common.errors.apiCodeReasons.platformOperations.retryLaterDeadLettered",
  retry_scheduled: "common.errors.apiCodeReasons.platformOperations.retryScheduled",
  rollback_failed: "common.errors.apiCodeReasons.platformOperations.rollbackFailed",
  runtime_node_freshness_touch_failed:
    "common.errors.apiCodeReasons.platformOperations.runtimeNodeFreshnessTouchFailed",
  runtime_sync_retry: "common.errors.apiCodeReasons.platformOperations.runtimeSyncRetry",
  runtime_target_fetch_failed:
    "common.errors.apiCodeReasons.platformOperations.runtimeTargetFetchFailed",
  start_failed: "common.errors.apiCodeReasons.platformOperations.startFailed",
  status_patch_failed: "common.errors.apiCodeReasons.platformOperations.statusPatchFailed",
  submit_failed_writeback_queued:
    "common.errors.apiCodeReasons.platformOperations.submitFailedWritebackQueued",
  submit_payload_kind_required:
    "common.errors.apiCodeReasons.platformOperations.submitPayloadKindRequired",
  sync_failed: "common.errors.apiCodeReasons.platformOperations.syncFailed",
  task_center_registry_read_failed:
    "common.errors.apiCodeReasons.platformOperations.taskCenterRegistryReadFailed",
  task_center_registry_unavailable:
    "common.errors.apiCodeReasons.platformOperations.taskCenterRegistryUnavailable",
  task_center_routing_mismatch:
    "common.errors.apiCodeReasons.platformOperations.taskCenterRoutingMismatch",
  task_close_failed: "common.errors.apiCodeReasons.platformOperations.taskCloseFailed",
  topology_projection_retry:
    "common.errors.apiCodeReasons.platformOperations.topologyProjectionRetry",
  unexpected_dispatch_error:
    "common.errors.apiCodeReasons.platformOperations.unexpectedDispatchError",
  unexpected_retry_dead_lettered:
    "common.errors.apiCodeReasons.platformOperations.unexpectedRetryDeadLettered",
  unexpected_retry_scheduled:
    "common.errors.apiCodeReasons.platformOperations.unexpectedRetryScheduled",
  unreachable_target: "common.errors.apiCodeReasons.platformOperations.unreachableTarget",
  unsupported_shape: "common.errors.apiCodeReasons.platformOperations.unsupportedShape",
  upload_file_close_failed: "common.errors.apiCodeReasons.platformOperations.uploadFileCloseFailed",
  write_failed: "common.errors.apiCodeReasons.platformOperations.writeFailed",
};
